module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-1700.93d8e0bc.svg";